// extracted by mini-css-extract-plugin
module.exports = {"container":"MB-z","links":"NB-z"};